import React from 'react';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const CategoryTiles = () => {
  const categories = [
    {
      id: 1,
      title: "Fresh Pastries",
      description: "Daily baked cornetti, sfogliatelle & more",
      icon: "Croissant",
      color: "var(--color-primary)",
      bgColor: "bg-primary/10",
      link: "/menu-showcase"
    },
    {
      id: 2,
      title: "Artisan Breads",
      description: "Traditional sourdough & Italian loaves",
      icon: "Wheat",
      color: "var(--color-accent)",
      bgColor: "bg-accent/10",
      link: "/menu-showcase"
    },
    {
      id: 3,
      title: "Custom Cakes",
      description: "Design your dream celebration cake",
      icon: "Cake",
      color: "var(--color-burnt-orange)",
      bgColor: "bg-[#E76F51]/10",
      link: "/menu-showcase"
    },
    {
      id: 4,
      title: "Catering Services",
      description: "Perfect for events & celebrations",
      icon: "ChefHat",
      color: "var(--color-pistachio)",
      bgColor: "bg-[#7FB069]/10",
      link: "/catering-excellence"
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
            Explore Our Offerings
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From morning pastries to celebration cakes, discover authentic Italian baking traditions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories?.map((category) => (
            <Link
              key={category?.id}
              to={category?.link}
              className="group"
            >
              <div className="h-full p-6 rounded-2xl bg-card border border-border hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1">
                <div className={`w-16 h-16 rounded-xl ${category?.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={category?.icon} size={32} color={category?.color} />
                </div>
                <h3 className="font-serif text-xl font-semibold text-foreground mb-2">
                  {category?.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {category?.description}
                </p>
                <div className="flex items-center gap-2 text-primary font-medium text-sm group-hover:gap-3 transition-all duration-300">
                  <span>Explore</span>
                  <Icon name="ArrowRight" size={16} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryTiles;